<div class="header" *ngIf="treesHeader">
    <ng-container *ngIf="treesHeader" [ngTemplateOutlet]="treesHeader"></ng-container>
</div>
<div class="main" *ngIf="trees">
    <fui-tree *ngFor="let tree of trees;trackBy: trackByFn" [tree]="tree" [toggled]="toggled" [attr.tree-item-label]="tree.title">
        <ng-template #treeheadercontext let-tree="tree">
            <ng-container *ngTemplateOutlet="treeHeaderContext; context: $any({tree: tree})"></ng-container>
        </ng-template>
    </fui-tree>
</div>
